import {Selectors} from '../Settings';

/**
 * Thumbnails
 */
export default class Thumbnails {
  constructor($thumbnailsSelector) {
    this.$testimonials = $(Selectors.testimonialsWrap);
    this.$thumbnails = $thumbnailsSelector;
    this.$thumbnail = this.$thumbnails.find(Selectors.thumbnail);

    this.bindHandlers();
    this.thumbnailActive(0);
  }

  bindHandlers() {
    let _self = this;

    this.$thumbnail.on('click', function () {
      _self.$testimonials.trigger('to.owl.carousel', [$(this).index()]);
    });

    this.$testimonials.on('translate.owl.carousel', function (e) {
      _self.thumbnailsInactive();
      _self.thumbnailActive(e.page.index);
    });
  }

  thumbnailsInactive() {
    this.$thumbnail.removeClass('act');
  }

  thumbnailActive(index) {
    this.$thumbnail.eq(index).addClass('act');
  }
}
